import dayjs from "dayjs";

export default class DateAdapter {
    constructor(dateFormat='DD-MM-YYYY') {
        this._dateFormat = dateFormat;
    }

    adapt(date) {
        return date.format(this._dateFormat)
    }

    static adaptDatetime(datetime){
        return dayjs(datetime).format('DD-MM-YYYY HH:mm:ss');
    }
}